import React, { useEffect } from 'react';
import Photo from './Photo';

/**
 * Bootstrap-styled modal rendered inline (no bootstrap JS needed), so the
 * stage dialogs behave the same whether or not the jQuery plugin is loaded.
 */
const Modal = ({ title, subtitle, photo, show, onClose, onSubmit, saving, size = 'lg', children }) => {
  // Escape closes, and the page behind must not scroll while the dialog is up.
  useEffect(() => {
    if (!show) return undefined;

    const onKey = (e) => { if (e.key === 'Escape' && !saving) onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.classList.add('modal-open');

    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.classList.remove('modal-open');
    };
  }, [show, saving, onClose]);

  if (!show) return null;

  return (
    <>
      <div className="modal fade show jm-modal" style={{ display: 'block' }} role="dialog">
        <div
          className={`modal-dialog modal-${size} modal-dialog-centered modal-dialog-scrollable`}
          role="document"
        >
          <div className="modal-content" style={{ border: 'none', borderRadius: 6 }}>
            <div
              className="modal-header align-items-center py-3"
              style={{ background: '#f8f9fa' }}
            >
              <div className="d-flex align-items-center" style={{ gap: 12, minWidth: 0 }}>
                <Photo src={photo} size={48} name={title} />
                <div style={{ minWidth: 0 }}>
                  <h5 className="modal-title mb-0" style={{ color: '#009879', fontWeight: 600 }}>
                    {title}
                  </h5>
                  {subtitle && (
                    <small className="text-muted" style={{ fontSize: '0.78rem' }}>{subtitle}</small>
                  )}
                </div>
              </div>
              <button type="button" className="close" onClick={onClose} aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            {/* modal-dialog-scrollable already makes this the scroll container;
                a second maxHeight here would fight it. */}
            <div className="modal-body">
              {children}
            </div>

            <div className="modal-footer py-2" style={{ background: '#f8f9fa' }}>
              <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>
                Close
              </button>
              {onSubmit && (
                <button type="button" className="btn btn-primary" onClick={onSubmit} disabled={saving}>
                  {saving ? 'Saving…' : 'Update'}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
};

export default Modal;
